import { render, staticRenderFns } from "./nuskin-in.vue?vue&type=template&id=1a2e2e76&scoped=true"
import script from "./nuskin-in.vue?vue&type=script&lang=js"
export * from "./nuskin-in.vue?vue&type=script&lang=js"
import style0 from "./nuskin-in.vue?vue&type=style&index=0&id=1a2e2e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2e2e76",
  null
  
)

export default component.exports